import type { SVGProps } from 'react';

const SvgEmailError = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M18 3H6C4.35 3 3 4.35 3 6v8c0 1.65 1.35 3 3 3h2c.55 0 1-.45 1-1s-.45-1-1-1H6c-.55 0-1-.45-1-1V7.15l5.51 3.15c.46.26.97.39 1.49.39s1.03-.13 1.49-.39L19 7.15V9c0 .55.45 1 1 1s1-.45 1-1V6c0-1.65-1.35-3-3-3m-5.5 5.56c-.31.17-.69.17-.99 0L5.52 5.14c.15-.08.3-.14.48-.14h12c.18 0 .34.06.48.14l-5.99 3.42z"
    />
    <path
      fill="currentcolor"
      d="M16 11c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5m3 5c0 .46-.11.89-.3 1.29l-3.98-3.98c.39-.19.82-.3 1.29-.3 1.65 0 3 1.35 3 3zm-6 0c0-.46.11-.89.3-1.29l3.98 3.98c-.39.19-.82.3-1.29.3-1.65 0-3-1.35-3-3z"
    />
  </svg>
);
export default SvgEmailError;
